module.exports = __webpack_public_path__ + "media/images/Distinguished-Flying-Cross-5601243b2d83dc1a82835c219c7f0d23.jpg";